import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';

import { useBillingItemRefresh } from '@/hooks/useBillingItemRefresh';
import Button from '@/ui/components/Button';

import { Props } from './types';

const RefreshBillingItem = ({ billingItem, refetchEncounter }: Props): JSX.Element | null => {
  const { mutate: refreshBillingItem, isPending } = useBillingItemRefresh({
    onSuccess: () => {
      if (refetchEncounter) {
        refetchEncounter();
      }
    }
  });

  if (!billingItem || !billingItem.id) {
    return null;
  }

  const handleRefresh = async () => {
    if (!billingItem.id) {
      return;
    }
    refreshBillingItem({ billingItemId: billingItem.id });
  };

  return (
    <div className="mt-4 border-t pt-4 border-gray-200 border-solid">
      <div className="flex flex-col space-y-2">
        <Button
          onClick={handleRefresh}
          disabled={isPending}
          className="flex items-center justify-center w-full"
          color="cyan">
          <FontAwesomeIcon icon={faSync} spin={isPending} className="mr-2" />
          {isPending ? 'Refreshing...' : 'Refresh Billing Item'}
        </Button>
      </div>
    </div>
  );
};

export default RefreshBillingItem;
